<template>
  <div class="form-container">
    <md-field>
      <label>Comment</label>
      <md-textarea v-model="node.comment" />
    </md-field>

    <div class="form-row">
      <md-switch v-model="node.is_enabled">
        Enabled
      </md-switch>

      <md-field>
        <label>Load Index</label>
        <md-input
          v-model="node.load_index"
          type="number"
          disabled
        />
      </md-field>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: "LocalDnsNodeForm",
    props: { node: { type: Object, required: true } },
    validations: {
        node: {
            ip: {required},
            server_address: {required},
            port: {required},
            settings: {required},
            provider: {required},
        }
    }
};
</script>

<style scoped lang="scss">
    .form-row {
      display: flex;
      justify-content: space-between;

      div {
        width: 65%;

        & + div {
          width: 30%;
        }
      }
    }
</style>
